const rowCountToClass = {
  1: "one field",
  2: "two fields",
  3: "three fields",
  4: "four fields",
  5: "five fields",
  6: "six fields",
};

const FixedFormRow = ({ cols, count, fieldMap }) => {
  console.log("COLS: ", cols);
  return (
    <div className={rowCountToClass[count]}>
      {cols.map((col) => fieldMap[col])}
    </div>
  );
};

export default FixedFormRow;
